import { theme } from '../../theme';
import { ROSTER } from '../Roster/tokens';

const { palette } = theme;

export const LIST = {
  font: ROSTER.font,
  ink: ROSTER.ink,
  muted: ROSTER.muted,
  surface: ROSTER.surface,
  cardBg: ROSTER.cardBg,
  cardShadow: ROSTER.cardShadow,
  divider: ROSTER.border,
  primary: palette.primary.main,
  selectedBg: '#EFEFFA',
  disabledBg: 'rgba(8, 8, 27, 0.12)',
  disabledFg: 'rgba(8, 8, 27, 0.26)',
  missedChip: { bg: '#FEE59A', fg: '#4D1C00' },
  dueChip: { bg: ROSTER.chip.monitoring.bg, fg: ROSTER.chip.monitoring.fg },
  notice: { bg: '#E8F4FD', fg: '#072254' },
  columns: { select: 52, teacher: 150, class: 168, grade: 80, benchmark: 256, preview: 112 },
} as const;
